// E7 (47024): the served credit write-off preview, debounced and stale-proof. { pv, refusal }: both null while there is nothing to ask, for a non-admin (403), or on an API without the route (404:
// the hook goes off for the session and the drawer keeps its own figures). A door refusal ({code, error, error_fr}) is returned as the refusal.
import { useEffect, useState } from 'react';
import api from '../../../services/api';
import { isMissingPreview } from '../orderPage/moneyDoorModel.mjs';

let MISSING = false;
export function useCreditWriteoffPreview(partnerId, body) {
  const [st, setSt] = useState({ pv: null, refusal: null });
  const sig = partnerId && body && !MISSING ? JSON.stringify(body) : '';
  useEffect(() => {
    if (!sig) { setSt({ pv: null, refusal: null }); return undefined; }
    let live = true;
    const h = setTimeout(() => {
      Promise.resolve().then(() => api.creditWriteoffPreview(partnerId, JSON.parse(sig))).then(r => {
        if (!live) return;
        if (isMissingPreview(r)) { MISSING = true; setSt({ pv: null, refusal: null }); return; }
        if (r && r.ok && r.data) setSt({ pv: r.data, refusal: null });
        else setSt({ pv: null, refusal: r && r.status !== 403 && r.data && r.data.code ? r.data : null });
      }).catch(() => { if (live) setSt({ pv: null, refusal: null }); });
    }, 350);
    return () => { live = false; clearTimeout(h); };
  }, [partnerId, sig]);
  return st;
}
